import { DayOfWeek } from '@fluentui/date-time-utilities';

/**
 * Common constants and methods
 */
const TimeConstants: {
    MillisecondsInOneDay: number;
    MillisecondsIn1Sec: number;
    MillisecondsIn1Min: number;
    MillisecondsIn15Mins: number;
    MillisecondsIn22Mins: number;
    MillisecondsIn30Mins: number;
    MillisecondsIn1Hour: number;
    MinutesInOneDay: number;
    MinutesInOneHour: number;
    SecondsInOneMinute: number;
    HoursInOneDay: number;
    DaysInOneWeek: number;
    AllDaysOfWeek: DayOfWeek[];
} = {
    MillisecondsInOneDay: 86400000,
    MillisecondsIn1Sec: 1000,
    MillisecondsIn1Min: 60000,
    MillisecondsIn15Mins: 900000,
    MillisecondsIn22Mins: 1320000,
    MillisecondsIn30Mins: 1800000,
    MillisecondsIn1Hour: 3600000,
    MinutesInOneDay: 1440,
    MinutesInOneHour: 60,
    SecondsInOneMinute: 60,
    HoursInOneDay: 24,
    DaysInOneWeek: 7,
    AllDaysOfWeek: [
        DayOfWeek.Sunday,
        DayOfWeek.Monday,
        DayOfWeek.Tuesday,
        DayOfWeek.Wednesday,
        DayOfWeek.Thursday,
        DayOfWeek.Friday,
        DayOfWeek.Saturday,
    ],
};
export default TimeConstants;
